import { zIndices as marvelZIndices } from '@marvelapp/theme';
// TODO add new ones here, this is to support old components
export const zIndices = Object.assign(Object.assign({}, marvelZIndices), { record: {
        background: 0,
        content: 1,
        controls: 2,
        modal: 3,
    } });
